<page-sidebar [ngClass]="{'size-guide': (parentView.sidebar === 'size-guide'), 'icms-open': client.isCms}"
              [backArrow]="!client.isS && parentView.sidebar !== 'size-guide'"
              [closeButton]="parentView.sidebar === 'how-to-measure' || parentView.sidebar === 'size-guide'"
              [(isOpen)]="parentView.isSidebarOpen"
              (isOpenChange)="handleIsOpenChange($event)"
              (closeRequest)="handleCloseRequest()">
    @switch (parentView.sidebar) {
    @case ('reviews') {
    <product-reviews [product]="parent.familyIds"
                     [productName]="product.data.name" />
    }
    @case ('details') {
    <product-general-details [parentView]="parentView"
                             [content]="content" />
    }
    @case ('gift-boxing') {
    <product-gift-boxing />
    }
    @case ('delivery') {
    <product-delivery-price [productId]="product.id"
                            [content]="{
                                returnNote: content.returnNote,
                                returnLink: content.returnLink,
                                returnLinkText: content.returnLinkText
                            }" />
    }
    @case ('klarna') {
    <basket-klarna-content-block class="w-12" />
    }
    @case ('xnotif') {
    <exponea-stock-notification class="w-12"
                                [model]="product" />
    }
    @case ('size-guide') {
    @if (parentView.sizeGuideVariant) {
    <product-size-guide [variant]="parentView.sizeGuideVariant"
                        [parentView]="parentView" />
    }
    }
    @case ('how-to-measure') {
    <how-to-measure [variant]="parentView.sizeGuideVariant" />
    }
    }
</page-sidebar>
